module.exports = __webpack_public_path__ + "static/media/clock-blue.865fc2c4.svg";